module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h4', {
    staticClass: "h4-a"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    attrs: {
      "href": "#/05_9781614230007_Foreword"
    }
  }, [_vm._v("Foreword, by Susan Greene")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('a', {
    attrs: {
      "href": "#/06_9781614230007_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-x"
  }, [_c('a', {
    attrs: {
      "href": "#/07_9781614230007_Introduction"
    }
  }, [_vm._v("Introduction. Why Marshall Field’s Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_c('a', {
    attrs: {
      "href": "#/08_9781614230007_CH01"
    }
  }, [_vm._v("1. From the Farm to the City: Making of a Merchant")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_c('span', {
    attrs: {
      "href": "#/09_9781614230007_CH02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Growth and Rebirth: Field, Leiter & Company")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_c('span', {
    attrs: {
      "href": "#/10_9781614230007_CH03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Fire and Survival: Aftermath of the Great Chicago Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_c('span', {
    attrs: {
      "href": "#/11_9781614230007_CH04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Change and Philanthropy: The Merchant’s Final Years")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_c('span', {
    attrs: {
      "href": "#/12_9781614230007_CH05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Continuing the Vision: The John Shedd Years")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_c('span', {
    attrs: {
      "href": "#/13_9781614230007_CH06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Progress and Despair: The Great Depression and the World’s Fair")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_c('span', {
    attrs: {
      "href": "#/14_9781614230007_CH07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. From the City to the Suburbs: The Changing Face of Retail")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_c('span', {
    attrs: {
      "href": "#/15_9781614230007_CH08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. A Child’s Dream: Christmas at Field’s")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_c('span', {
    attrs: {
      "href": "#/16_9781614230007_CH09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Winds of Change: BATUS and Target")])]), _vm._v(" "), _c('p', {
    staticClass: "normal0"
  }, [_c('span', {
    attrs: {
      "href": "#/17_9781614230007_CH10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. An Icon Vanishes: The Coming of Macy’s")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1a"
  }, [_c('span', {
    attrs: {
      "href": "#/18_9781614230007_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue. State Street Today")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('span', {
    attrs: {
      "href": "#/19_9781614230007_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix. Marshall Field’s Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('span', {
    attrs: {
      "href": "#/20_9781614230007_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('span', {
    attrs: {
      "href": "#/21_9781614230007_Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31723698","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_9781614230007_Contents.vue
// module id = 66
// module chunks = 0